import React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, GlobalStyles } from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import 'moment/locale/pt';

const CustomDatePicker = (props) => {

    const {
        value = '',
        onChange = () => { },
        label = ''
    } = props;

    // Styled wrapper for consistent input styling
    const StyledTextField = styled(TextField)(({ theme }) => ({
        '& .MuiOutlinedInput-root': {
            borderRadius: '16px',
            fontFamily: 'Ubuntu, sans-serif',
            fontSize: '16px',
            color: '#00214D !important',
            '& .MuiSvgIcon-root': {
                color: '#00214D !important',
                fontSize: '26px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: '1px solid #00214D !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: '1px solid rgba(20, 20, 20, 0.16) !important',
                borderRadius: '16px',
                background: `linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), linear-gradient(255deg, rgba(255, 255, 255, 0.50) 0%, rgba(244, 246, 250, 0.80) 100%, rgba(205, 212, 229, 0.50) 100%)) !important`,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                color: '#515151 !important',
                border: '1px solid #00214D !important',
            },
        },
        '& .MuiInputLabel-root': {
            color: '#00214D !important',
            fontSize: '16px',
            fontFamily: 'Ubuntu, sans-serif',
            fontWeight: 400,
            lineHeight: '24px',
        },
    }));
    
    const GlobalYearButtonStyles = () => (
        <GlobalStyles
            styles={{
            '.MuiPickersYear-yearButton.Mui-selected': {
                backgroundColor: '#141414 !important',
                color: '#fff !important',
            },
            '.MuiPickersYear-yearButton.Mui-selected:hover, .MuiPickersYear-yearButton.Mui-selected:focus': {
                backgroundColor: '#141414 !important',
                color: '#fff !important',
            },
            '.MuiPickersYear-yearButton:hover': {
                backgroundColor: '#fff !important',
                color: '#141414 !important',
                border: '1px solid rgba(255, 255, 255, 0.50)',
                boxShadow:
                '0px 4px 4px rgba(154, 161, 186, 0.24), 0px 8px 24px rgba(154, 161, 186, 0.20)',
            },
            '.MuiPickersYear-yearButton:focus': {
                backgroundColor: '#fff !important',
                color: '#141414 !important',
                border: '1px solid rgba(255, 255, 255, 0.50)',
                boxShadow:
                '0px 4px 4px rgba(154, 161, 186, 0.24), 0px 8px 24px rgba(154, 161, 186, 0.20)',
            },
            }}
        />
    );
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoContainer components={['DatePicker']}>
                <GlobalYearButtonStyles />
                <DatePicker 
                    value={value}
                    onChange={onChange}
                    label={label} 
                    slots={{
                        textField: (params) => <StyledTextField {...params} />,
                    }}
                    slotProps={{
                        day: {
                            sx: {
                                color: '#515151 !important',
                                backgroundColor: 'transparent !important',
                                border: 'none',
                                borderRadius: '8px',
                                paddingBlock: '4px',
                                boxShadow: 'none',
                                '&.Mui-selected': {
                                    backgroundColor: '#141414 !important',
                                    color: '#fff !important',
                                    borderRadius: '8px',
                                    paddingBlock: '4px',
                                    border: '1px solid rgba(255, 255, 255, 0.50) !important',
                                    boxShadow: '0px 4px 4px 0px rgba(154, 161, 186, 0.24), 0px 8px 24px 0px rgba(154, 161, 186, 0.20) !important',
                                },
                                '&:hover': {
                                    backgroundColor: '#fff !important',
                                    color: '#141414 !important',
                                    border: '1px solid rgba(20, 20, 20, 0.16) !important',
                                    boxShadow: '0px 4px 4px 0px rgba(154, 161, 186, 0.24), 0px 8px 24px 0px rgba(154, 161, 186, 0.20) !important',
                                },
                                '&:focus': {
                                    backgroundColor: '#141414 !important',
                                    color: '#fff !important',
                                    borderRadius: '8px',
                                    paddingBlock: '4px',
                                    border: '1px solid rgba(255, 255, 255, 0.50) !important',
                                    boxShadow: '0px 4px 4px 0px rgba(154, 161, 186, 0.24), 0px 8px 24px 0px rgba(154, 161, 186, 0.20) !important',
                                },
                            },
                        },
                        year: {
                            sx: {
                                '&.Mui-selected': {
                                    backgroundColor: '#141414 !important',
                                    color: '#fff !important',
                                    '&:hover, &:focus': {
                                        backgroundColor: '#141414 !important',
                                        color: '#fff !important',
                                    },
                                },
                                '&:hover': {
                                    backgroundColor: '#fff !important',
                                    color: '#141414 !important',
                                    border: '1px solid rgba(255, 255, 255, 0.50) !important',
                                    boxShadow: '0px 4px 4px 0px rgba(154, 161, 186, 0.24), 0px 8px 24px 0px rgba(154, 161, 186, 0.20) !important',
                                },
                                '&:focus': {
                                    backgroundColor: '#fff !important',
                                    color: '#141414 !important',
                                    border: '1px solid rgba(255, 255, 255, 0.50) !important',
                                    boxShadow: '0px 4px 4px 0px rgba(154, 161, 186, 0.24), 0px 8px 24px 0px rgba(154, 161, 186, 0.20) !important',
                                },
                            },
                        },
                        openPickerButton: {
                            sx: {
                                color: 'rgba(0,33,77,0.08) !important',
                                '&:hover': {
                                    backgroundColor: 'rgba(0,33,77,0.08) !important',
                                },
                            },
                        },
                    }}
                />   
            </DemoContainer>
        </LocalizationProvider>
    );
};

export default CustomDatePicker;